import { map } from 'lodash';

export interface IStudentCptCode {
  cptCodeMappingId: number;
  isActive: boolean;
}

export interface ISaveStudentCptCodeRequest {
  encounterSk: string;
  studentSk: string[];
  studentCPTCodes: IStudentCptCode[];
}

export type SaveStudentCptCodeResponse = string;


export class SaveStudentCptCodeRequest {
  encounterSk: string;
  studentSk: string[];
  studentCPTCodes: StudentCptCode[];
  constructor(data: ISaveStudentCptCodeRequest) {
    this.encounterSk = data?.encounterSk;
    this.studentSk = data?.studentSk;
    this.studentCPTCodes = map(
      data?.studentCPTCodes,
      (cpt: StudentCptCode) => new StudentCptCode(cpt)
    );
  }
}

export class StudentCptCode implements IStudentCptCode {
  cptCodeMappingId: number;
  isActive: boolean;
  constructor(data: IStudentCptCode) {
    this.cptCodeMappingId = data?.cptCodeMappingId;
    this.isActive = data?.isActive;
  }
}
